<template>
  <div>
    <div class="title">현재 대기중</div>
    <div class="waiting">
      <div class="length">{{ (10000 > list.length) ? list.length : 9999 }}</div>
      <div class="teams">팀</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['list'],
  name: 'waitingTeams',
  components: {
  }
}
</script>

<style lang="scss" scoped>
@import "@/css/style.scss";
.title {
  padding: 16px 0 0 0;
  font-size: 27px;
  font-weight: $medium;
  color: $gray_400;

  @include fhd_combo {
    padding: 24px 0 0 0;
    font-size: 40px;
  }

  @include qhd_combo {
    padding: 32px 0 0 0;
    font-size: 53px;
  }
}

.waiting {
  display: flex;
  align-items: center;
  padding: 1px 0 17px 0;

  @include fhd_combo {
    padding: 2px 0 24px 0;
  }
  @include qhd_combo {
    padding: 2px 0 32px 0;
  }
}

.length {
  font-size: 72px;
  font-weight: $bold;
  color: $white;
  padding: 0 5px 0 0;

  @include fhd_combo {
    font-size: 108px;
    padding: 0 8px 0 0;
  }

  @include qhd_combo {
    font-size: 144px;
    padding: 0 11px 0 0;
  }
}

.teams {
  font-size: 45px;
  font-weight: $bold;
  color: $white;

  @include fhd_combo {
    font-size: 68px;
  }

  @include qhd_combo {
    font-size: 90px;
  }
}
</style>
